// extracted by mini-css-extract-plugin
export default {"withdrawn-tag":"PermissionStatus_withdrawn-tag__rXwFN"};